import { useState } from 'react';

/**
 * Where the brand images live: files under `apps/app/public/brand/` are served here unchanged.
 *
 * @since 1.1.0
 */
export const BRAND_ASSET_PATH = '/brand';

/**
 * Intrinsic size of the logo files, so the browser reserves the box before the image loads.
 *
 * @since 1.3.0
 */
export const BRAND_IMAGE_SIZE = 600;

/**
 * Props for the brand mark.
 *
 * @since 1.1.0
 */
export interface BrandMarkProps {
    /** @type {'on-dark' | 'on-light'} which logo file to use: dark chrome or the white login card */
    variant: 'on-dark' | 'on-light';
    className: string;
}

/**
 * The FKW Digital logo, with the typographic wordmark as the fallback when the image is missing.
 *
 * @since 1.1.0
 * @param props - the variant and the block class the caller styles
 * @returns the logo image, or the wordmark when the image is unavailable
 */
export function BrandMark({ variant, className }: BrandMarkProps) {
    const [isImageMissing, setIsImageMissing] = useState(false);

    if (isImageMissing) {
        return (
            <div className={`${className}__mark`}>
                FKWD<span>/</span>QC
            </div>
        );
    }

    return (
        <img
            alt="FKW Digital"
            className={`${className}__logo`}
            height={BRAND_IMAGE_SIZE}
            onError={() => setIsImageMissing(true)}
            src={`${BRAND_ASSET_PATH}/fkwd-logo-${variant}.png`}
            width={BRAND_IMAGE_SIZE}
        />
    );
}
